import { makeRequest } from "@framework/notifications/request";
import {
  NotificationsStatus,
  DEFAULT_NOTIFICATIONS_STATUS,
} from "@voxmedia/duet-context/context/notifications-context";

interface StatusForUserResponse {
  statusForUser: NotificationsStatus;
}

const query = /* GraphQL */ `
  query StatusForUser {
    statusForUser {
      unseen
      unread
      lastViewed
    }
  }
`;

/**
 * Fetch notification status for a user from the Notifications service.
 *
 * @param serverURL - Base URL of the Notifications service
 * @param token - Bearer token for authenticated requests
 */
export const fetchStatusForUser = async (params: {
  token: string;
  serverURL?: string;
}): Promise<NotificationsStatus> => {
  const {
    token,
    serverURL = process.env.NEXT_PUBLIC_NOTIFICATIONS_SERVICE_URL,
  } = params;

  if (!serverURL) {
    throw new Error("Missing config value for Notifications Service URL.");
  }

  const apiURL = new URL("/api", serverURL).toString();

  const response = await makeRequest<StatusForUserResponse>(
    apiURL,
    query,
    {},
    token,
  );

  return response.data?.statusForUser || DEFAULT_NOTIFICATIONS_STATUS;
};
